export default __webpack_public_path__ + "static/media/backoffice-invoice-sample.a3f7e654.jpg";